var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIconPasajeros(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M99.6,100H87.5c-2.6-16.5-15.8-29.4-32.4-31.7L43.6,56.4c2.1-0.3,4.3-0.4,6.4-0.4C75.6,56,96.7,75.2,99.6,100z  M19.7,66.3C9.2,74.2,2,86.3,0.4,100h12.1c1.6-10.3,7.5-19.3,15.6-25L19.7,66.3z M50,12c-6.6,0-12,5.4-12,12s5.4,12,12,12 s12-5.4,12-12S56.6,12,50,12 M50,0c13.3,0,24,10.7,24,24S63.3,48,50,48S26,37.3,26,24S36.7,0,50,0L50,0z M0.4,23.2v11.5L63.4,100 h11.1L0.4,23.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIconPasajeros);
export default __webpack_public_path__ + "static/media/motion_icon-pasajeros.772eaa53.svg";
export { ForwardRef as ReactComponent };